<template>
  <div class="pc-container">
    <div v-for="(item,index) in data" :key="index">
      <component :is="item.type" :data="item"></component>
    </div>
  </div>
</template>

<script>
import {companyData} from "@/data";
export default {
  name: 'CompanyView',
  data(){
    return {
      data:companyData
    }
  }
}
</script>
<style lang="scss" scoped></style>
